import { pipe } from "fp-ts/lib/function"
import { POApi } from "../POApi"
import * as t from 'io-ts'
import { Maybe } from "@mxt/zio/codec"
import { ZIO } from "@mxt/zio"

export namespace SurrenderValuePaymentForAutoTerminatedPolicyService {
  export const getValidAutoTerminatedPolicy = (policyNum: string) => pipe(
    POApi.post(`wf-api/policy/valid-auto-terminated-policy`)(t.type({
      body: t.type({
        policyNum: t.string,
        validCode: t.string
      }),
      responseStatus: Maybe(t.type({
        message: Maybe(t.string)
      }))
    }))({
      body: {
        policyNum: policyNum
      }
    }),
    ZIO.map((terminatedPolicyRes) => terminatedPolicyRes.body)
  )
}